import React from "react";
import PropTypes from "prop-types";

/**
 * undefined means authentication has not been checked.
 * null means not authenticated.
 * filled object means authenticated.
 * @type {React.Context<null>}
 */
const AuthenticatedUserContext = React.createContext(null);

export default AuthenticatedUserContext;

export function withAuthenticatedUserContext(Component) {
    return function contextComponent(props) {
        return (
            <AuthenticatedUserContext.Consumer>
                {context => <Component {...props} authenticatedUserContext={context} />}
            </AuthenticatedUserContext.Consumer>
        )
    }
}
export const AuthenticatedUserContextPropTypes = PropTypes.shape({
    user: PropTypes.object,
    setUser: PropTypes.func,
    login: PropTypes.func,
    logout: PropTypes.func,
    otpVerification: PropTypes.func,
    navigationTransition: PropTypes.func
});
